import { useQuery } from '@tanstack/react-query';
import { Card } from '@projexn/ui';
import { api } from '../lib/api';

interface Workload {
  scope: 'tenant' | 'user';
  userId: string | null;
  activeTenders: number;
  openRfis: number;
  scheduledSiteVisits: number;
  draftQuotes: number;
  totalValueCents: number;
  computedAt: string;
}

export function WorkloadPage() {
  const wQ = useQuery({
    queryKey: ['workload'],
    queryFn: () => api.get<Workload>('/api/workload'),
  });

  if (wQ.isLoading) {
    return <Card className="p-6 text-sm text-zinc-500">Loading…</Card>;
  }
  if (wQ.isError) {
    return <Card className="p-6 text-sm text-red-700">{(wQ.error as Error).message}</Card>;
  }
  const w = wQ.data!;

  const stats: Array<[string, string]> = [
    ['Active tenders', w.activeTenders.toString()],
    ['Open RFIs', w.openRfis.toString()],
    ['Scheduled site visits', w.scheduledSiteVisits.toString()],
    ['Draft quotes', w.draftQuotes.toString()],
    ['Total active value', `$${(w.totalValueCents / 100).toLocaleString()}`],
  ];

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-xl font-semibold">Workload</h1>
        <p className="text-sm text-zinc-500">
          Tenant-wide snapshot · computed {new Date(w.computedAt).toLocaleString()}
        </p>
      </header>

      <section className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
        {stats.map(([label, value]) => (
          <Card key={label} className="p-5">
            <p className="text-xs uppercase tracking-wide text-zinc-500">{label}</p>
            <p className="mt-1 text-2xl font-semibold tabular-nums">{value}</p>
          </Card>
        ))}
      </section>
    </div>
  );
}
